/* Shared palette + style atoms for the role dashboards (mirrors the Studio in App.jsx). */
export const C = {
  bg: "#0E1217", panel: "#161B22", raised: "#1C232C", rail: "#222A33",
  border: "#2A323D", hi: "#E6ECF2", mid: "#9AA7B4", dim: "#5E6B79",
  indigo: "#6E8BFF", indigoDim: "#33406b", amber: "#F2A93B",
  green: "#4FB477", red: "#E5645B", purple: "#A47BE0", blue: "#6E8BFF",
};

/* Visual identity per app role — used for badges and dashboard accents. */
export const ROLE_META = {
  admin:        { label: "Admin",        c: C.red,    blurb: "System Console" },
  researcher:   { label: "Researcher",   c: C.indigo, blurb: "Research" },
  experimenter: { label: "Experimenter", c: C.amber,  blurb: "Sessions" },
  participant:  { label: "Participant",  c: C.green,  blurb: "My Studies" },
};

export const STATUS_C = { active: C.green, draft: C.amber, archived: C.dim, closed: C.dim };

export const ui = {
  page: { flex: 1, minHeight: 0, overflowY: "auto", background: C.bg, color: C.hi, fontFamily: "var(--ui)" },
  wrap: { maxWidth: 1100, margin: "0 auto", padding: "22px 22px 60px" },
  h2: { fontSize: 13, fontWeight: 700, color: C.hi, textTransform: "uppercase", letterSpacing: 0.6, margin: "26px 0 12px", display: "flex", alignItems: "center", gap: 8 },
  hint: { color: C.dim, fontSize: 12, fontFamily: "var(--mono)", fontWeight: 400, textTransform: "none", letterSpacing: 0 },
  grid: { display: "grid", gap: 14, gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))" },
  card: { background: C.raised, border: `1px solid ${C.border}`, borderRadius: 12, padding: 16 },
  cardHead: { display: "flex", alignItems: "center", gap: 10, marginBottom: 10 },
  cardTitle: { color: C.hi, fontWeight: 700, fontSize: 15 },
  row: { display: "flex", alignItems: "center", gap: 10 },
  metricVal: { fontFamily: "var(--mono)", fontWeight: 800, fontSize: 24 },
  metricLabel: { color: C.dim, fontSize: 10.5, textTransform: "uppercase", letterSpacing: 0.6 },
  badge: { fontSize: 9.5, fontFamily: "var(--mono)", fontWeight: 700, padding: "2px 7px", borderRadius: 5, border: "1px solid", letterSpacing: 0.4, whiteSpace: "nowrap" },
  btn: { display: "inline-flex", alignItems: "center", gap: 6, padding: "7px 13px", borderRadius: 8, border: "none", fontWeight: 700, fontSize: 12.5, cursor: "pointer", fontFamily: "var(--ui)" },
  btnGhost: { display: "inline-flex", alignItems: "center", gap: 6, padding: "6px 12px", borderRadius: 8, border: `1px solid ${C.border}`, background: "transparent", color: C.mid, fontWeight: 600, fontSize: 12, cursor: "pointer", fontFamily: "var(--ui)" },
  input: { background: "#0A0D11", border: `1px solid ${C.border}`, borderRadius: 8, color: C.hi, padding: "7px 10px", fontSize: 13, fontFamily: "var(--ui)", outline: "none" },
  table: { width: "100%", borderCollapse: "collapse", fontSize: 12.5 },
  th: { textAlign: "start", padding: "8px 10px", borderBottom: `1px solid ${C.border}`, color: C.dim, fontWeight: 600, fontFamily: "var(--mono)", textTransform: "uppercase", fontSize: 10.5, letterSpacing: 0.5 },
  td: { padding: "8px 10px", borderBottom: `1px solid ${C.rail}`, color: C.hi },
  empty: { color: C.mid, fontSize: 13, textAlign: "center", padding: "30px 16px", border: `1px dashed ${C.border}`, borderRadius: 12, background: C.panel },
};

export function Badge({ children, color = C.mid }) {
  return <span style={{ ...ui.badge, color, borderColor: color + "55" }}>{children}</span>;
}
